import React from "react";
import { NavLink } from "react-router-dom";

export default function PremiumTabs({ label, items }) {
  return (
    <nav className="premium-tabs nav nav-tabs" aria-label={label}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
